export default __webpack_public_path__ + "static/media/ebike2.c2cbed77.png";